import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_PROSPECTION } from "../prospection.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateProspectionInput } from "../../../__generated__/globalTypes";
import {
  UpdateProspectionMutation,
  UpdateProspectionMutationVariables,
} from "../../../__generated__/UpdateProspectionMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateProspection = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateProspectionInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateProspectionMutation,
    UpdateProspectionMutationVariables
  >(UPDATE_PROSPECTION, {
    refetchQueries: ["ProspectionsQuery", "ProspectionQuery"],
    update(cache) {
      evictFields(cache, ["prospection", "prospections"]);
    },
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateProspection?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateProspection?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
